import axios from "axios";
import { useAppSelector } from "../store";
const user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user") || "") : null;
let userToken = user?.token;
//let userToken = user?.user?.token;

export const http = axios.create({
    baseURL: process.env.REACT_APP_FILEMANAGEMENTAPI_URL,
    headers : {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Credentials": true
    }
});

export const httpAttachments = axios.create({
    baseURL: process.env.REACT_APP_FILEMANAGEMENTAPI_URL,
    headers : {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "multipart/form-data",
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Credentials": true
    }
});

export const GETAttachments = (action: any) => {
    return http.get(action);
};
export const POSTAttachments = (action: any, data: any) => {
    return httpAttachments.post(action, data);
};
export const PATCHAttachments = (action: any, data: any) => {
    return httpAttachments.patch(action, data);
};
export const PUTAttachments = (action: any, data: any) => {
    return httpAttachments.put(action, data);
};
export const DELETEAttachments = (action: any) => {
    return http.delete(action);
}
